var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66732 10.6665C4.85621 10.6665 5.01454 10.6026 5.14232 10.4748C5.2701 10.3471 5.33398 10.1887 5.33398 9.99984C5.33398 9.81095 5.2701 9.65261 5.14232 9.52484C5.01454 9.39706 4.85621 9.33317 4.66732 9.33317C4.47843 9.33317 4.3201 9.39706 4.19232 9.52484C4.06454 9.65261 4.00065 9.81095 4.00065 9.99984C4.00065 10.1887 4.06454 10.3471 4.19232 10.4748C4.3201 10.6026 4.47843 10.6665 4.66732 10.6665ZM4.00065 8.6665H5.33398V5.33317H4.00065V8.6665ZM6.66732 9.99984H12.0007V8.6665H6.66732V9.99984ZM6.66732 7.33317H12.0007V5.99984H6.66732V7.33317ZM2.66732 13.3332C2.30065 13.3332 1.98676 13.2026 1.72565 12.9415C1.46454 12.6804 1.33398 12.3665 1.33398 11.9998V3.99984C1.33398 3.63317 1.46454 3.31928 1.72565 3.05817C1.98676 2.79706 2.30065 2.6665 2.66732 2.6665H13.334C13.7007 2.6665 14.0145 2.79706 14.2757 3.05817C14.5368 3.31928 14.6673 3.63317 14.6673 3.99984V11.9998C14.6673 12.3665 14.5368 12.6804 14.2757 12.9415C14.0145 13.2026 13.7007 13.3332 13.334 13.3332H2.66732ZM2.66732 11.9998H13.334V3.99984H2.66732V11.9998Z",
    fill: "#5F6368",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescribe);
export default __webpack_public_path__ + "static/media/describe.f967d3370ae12a01d40ff5977be1f0e5.svg";
export { ForwardRef as ReactComponent };